import { I18n } from '@calendly/i18n'
import { ContextualBanner } from '@calendly/ui/components/contextual-banner'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'

import { useGetUserQuery } from 'common'
import { userDateFormat } from 'services/time_format'

import { flowKindSelector, eventSelector, isInviteeOnlyRescheduleSelector } from '../selectors'
import { FlowKind } from '../slice'


export const EventCancellationBanner = () => {
  const { data: { date_notation: dateNotation, locale, timezone } } = useGetUserQuery()
  const flowKind = useSelector(flowKindSelector)
  const event = useSelector(eventSelector)
  const isInviteeOnlyReschedule = useSelector(isInviteeOnlyRescheduleSelector)

  if (flowKind !== FlowKind.reschedule) return null

  const date = userDateFormat(
    moment(event.startTime).tz(timezone),
    dateNotation,
    'date_small_with_year',
    locale
  )

  return (
    <ContextualBanner variant="standard" spacingBottom="24">
      {isInviteeOnlyReschedule
        ? I18n.t('publisher.send_from_calendly.cancellation_notice.invitee', { date })
        : I18n.t('publisher.send_from_calendly.cancellation_notice.event', { date })}
    </ContextualBanner>
  )
}
